import { useController, useFormContext } from "react-hook-form";
import Label from "./Label";
import ErrorLabel from "./ErrorLabel";

function TextArea({
  label = null,
  name,
  labelClassName = "last:mb-0",
  inputType = "text",
  ...props
}) {
  const { control } = useFormContext();
  const { fieldState, field } = useController({ name, control });
  return (
    <label htmlFor={name} className={`block w-full ${labelClassName}`}>
      <Label>{label ?? name}</Label>
      <textarea
        className="input !border input__white-smoke w-full"
        rows={4}
        {...props}
        {...field}
      ></textarea>
      {fieldState?.error && (
        <ErrorLabel>
          {fieldState?.error ? fieldState?.error?.message ?? "Error" : ""}
        </ErrorLabel>
      )}
    </label>
  );
}

export { TextArea };
